import React, { useState } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import {
  useMediaQuery,
  withWidth,
  useTheme,
  Button,
  Box,
} from "@material-ui/core";
import { getConf } from "@configuratorware/configurator-frontendgui/App/configuration.js";
import { T } from "@configuratorware/configurator-frontendgui/Framework/i18n";
import Carousel from "@configuratorware/configurator-frontendgui/Framework/Components/Carousel";
import customClassName from "@configuratorware/configurator-frontendgui/App/Utils/customClassName";
import ProductPart from "./CustomProductPart";

const useStyles = makeStyles(
  (theme) => {
    return {
      root: {
        zIndex: 1,
        "&.horizontal": {
          position: "absolute",
          bottom: 8,
          height: "auto",
          // the available width (see container) is reduced by the width of the two arrows
          width: "calc(100% - 72px)",
          [theme.breakpoints.down("xs")]: {
            width: "calc(100% - 32px)",
            padding: "0 16px",
          },
        },
        "&.vertical": {
          float: "left",
          height: "100%",
          width: "auto",
          marginLeft: theme.creator.productPartsList.marginLeft,
          paddingTop: theme.creator.productPartsList.paddingTop,
          [theme.breakpoints.down("md")]: {
            paddingTop: 35,
          },
        },
      },
    };
  },
  { name: "ProductPartsList" }
);

const ProductPartsList = ({
  displaySwitchedOptions,
  onSelect,
  optionclassifications,
  selectedoptionclassification,
  showStartHere,
  ProductPartComponent,
  CallToActionComponent,
  width,
  isLoggedIn,
}) => {
  const classes = useStyles();
  const [anchorRef, setAnchorRef] = useState(null);

  // to show productsPartList in vertical model when not in mobile view
  const dock = getConf("dock");
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("xs"));
  const vertical = dock ? dock === "left" : !isMobileScreen;

  const { isCustomColor } = useSelector((state: any) => {
    const colorOptionClassification =
      state.configurator.configuration.optionclassifications.find(
        (item) => item?.identifier === "color_combination"
      );
    return {
      isCustomColor:
        colorOptionClassification.selectedoptions &&
        colorOptionClassification.selectedoptions[0]?.identifier ===
          "individual_color_combination",
    };
  });

  return (
    <>
      <Carousel
        className={clsx(classes.root, customClassName("components"))}
        vertical={vertical}
      >
        {(isCustomColor
          ? optionclassifications
          : optionclassifications.filter(
              (item) => item.identifier === "color_combination"
            )
        ).map((option, index) => {
          const refProps = {
            ...(index === 0 && { setAnchorRef }),
          };

          return (
            <ProductPartComponent
              key={"optionclassificationitem" + option.identifier}
              displaySwitchedOptions={displaySwitchedOptions}
              onSelect={onSelect}
              optionclassification={option}
              selectedOption={selectedoptionclassification}
              verticalMode={vertical}
              {...refProps}
            />
          );
        })}
      </Carousel>
      {showStartHere && width !== "xs" && (
        <CallToActionComponent
          offsetDirection={vertical ? "right" : "top"}
          anchorRef={anchorRef}
          perpendicularOffset={vertical ? -15 : 0}
          offset={15}
          label={T("creator.startHere")}
          className={customClassName("begin-here-creator")}
        />
      )}
    </>
  );
};

ProductPartsList.defaultProps = {
  onSelect: () => {},
  optionclassifications: [],
  selectedoptionclassification: {},
  showStartHere: false,
  vertical: true,
  ProductPartComponent: ProductPart,
};

ProductPartsList.propTypes = {
  onSelect: PropTypes.func,
  optionclassifications: PropTypes.array,
  selectedoptionclassification: PropTypes.object,
  showStartHere: PropTypes.bool,
  vertical: PropTypes.bool,
  displaySwitchedOptions: PropTypes.bool,
  ProductPartComponent: PropTypes.elementType,
  CallToActionComponent: PropTypes.elementType,
  width: PropTypes.string,
};

export default withWidth({ initialWidth: "lg" })(ProductPartsList);
